// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"ec60b357","175":"6e9753dd","665":"b6ece7c0","872":"89f80240"}[chunkId] + ".chunk.js";
};